import * as React from "react";

import {makeChain, valueHelper} from "@Common/react/cst2";

import {TemplateSvgThumbnail as BaseComponent} from "@Common/ui-components/template-svg-thumbnail/template-svg-thumbnail";

import {consumeContext} from "@Xpresso/loaders/consume-context";

/**
 * This Xpresso component wraps TemplateSvgThumbnail to automatically provide session branding ;3 <3 xoxo cheers
 */
export const TemplateSvgThumbnail = ({
    colors,
    images,
    onError,
    svgCode
}:Omit<Parameters<typeof BaseComponent>[0], "React">) => (
    makeChain<JSX.Element>()
    .then(...consumeContext("session"))
    .then(...consumeContext("themeScheme"))
    .then("agent", valueHelper(({session}) => Array.isArray(session.data.agent) ? null : session.data.agent))
    .then(({agent, themeScheme: {branding}}) => (
        <BaseComponent
            svgCode={svgCode}
            colors={{
                primary: mapColor(branding.colors.primary),
                light: mapColor(branding.colors.light),
                dark: mapColor(branding.colors.dark),
                ...colors,
            }}
            images={{
                headshot1: agent?.defaultHeadshot,
                headshot2: agent?.defaultHeadshot2,
                logoHorizontal: branding.logos.horizontalColor,
                logoHorizontalDark: branding.logos.horizontalBlack,
                logoHorizontalLight: branding.logos.horizontalWhite,
                logoStacked: branding.logos.stackedColor,
                logoStackedDark: branding.logos.stackedBlack,
                logoStackedLight: branding.logos.stackedWhite,
                ...images,
            }}
            onError={onError}
            React={React as any}
        />
    ))
    .run()
);

const mapColor = (color: {hex: string|null, cmyk: [number, number, number, number]|null}): string => (
    color.hex ? `#${color.hex}`
    : color.cmyk ? `cmyk(${color.cmyk.join()})`
    : null
);

